import { flatten } from 'xstate/lib/utils';
export default function getTaskMap(groups) {
    return flatten(groups.map((group) => group.tasks)).reduce((acc, item) => {
        acc[item.taskId] = item;
        return acc;
    }, {});
}
